import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: 'What is LoadApp?',
    answer:
      'LoadApp is an all-in-one fleet management platform designed for trucking companies and owner-operators. It handles dispatch, driver management, document storage, and billing — all from a single dashboard.',
  },
  {
    question: 'Is there a free plan?',
    answer:
      'Yes! Our Starter plan is completely free and includes up to 5 loads per month, 1 driver, and access to the basic dashboard. No credit card required.',
  },
  {
    question: 'How long does setup take?',
    answer:
      'Most teams are up and running in under 5 minutes. Create your account, add your drivers and vehicles, and you\'re ready to dispatch your first load.',
  },
  {
    question: 'Is my data secure?',
    answer:
      'Absolutely. LoadApp uses enterprise-grade encryption, row-level security policies, and is hosted on SOC 2 compliant infrastructure. Your data is always protected.',
  },
  {
    question: 'Can I import existing data?',
    answer:
      'Yes, you can import drivers, vehicles, and historical load data via CSV. Our team can also help with custom data migration for Enterprise plans.',
  },
  {
    question: 'What kind of support do you offer?',
    answer:
      'Starter plans get email support. Professional plans include priority support with faster response times. Enterprise plans include a dedicated account manager and phone support.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="bg-gray-50 py-24">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-sm font-semibold uppercase tracking-widest text-blue-600 mb-3">
          FAQ
        </p>
        <h2 className="text-4xl font-bold text-gray-900 mb-12">
          Got Questions? We&apos;ve Got Answers.
        </h2>

        <div className="max-w-3xl mx-auto text-left">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200">
              <button
                onClick={() => toggle(index)}
                className="flex justify-between items-center w-full py-5 cursor-pointer text-left"
              >
                <span className="text-lg font-medium text-gray-900">
                  {faq.question}
                </span>
                <ChevronDown
                  className="text-gray-500 flex-shrink-0 ml-4 transition-none"
                  size={20}
                  style={{
                    transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              </button>
              {openIndex === index && (
                <p className="pb-5 text-gray-600 leading-relaxed">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
